import ahoy from 'ahoy.js'
import { createContext, useContext } from 'react'

export type Track = (name: string, properties: { language: string }) => void

export const trackWithAhoy: Track = (name, properties) => {
  ahoy.track(name, properties)
}

export const dontTrack: Track = () => {}

/**
 * LF-897/LF-915: interaction telemetry for the results page. The report screen
 * provides `dontTrack` in read-only view (the Metabase link, sample reports) so
 * nothing under it records engagement — a staff member reading a session, or a
 * coach exploring a sample, would otherwise look like a coach working a
 * client's results. Everywhere else it's plain ahoy.
 *
 * Page views are separate: ApplicationController#track_action records those
 * server-side for every GET.
 */
export const TrackContext = createContext<Track>(trackWithAhoy)

export function useTrack(): Track {
  return useContext(TrackContext)
}
